import {
  Wifi, Snowflake, Flame, CookingPot, WashingMachine, Tv, Car, ArrowUpDown,
  PanelTop, Sun, Trees, Waves, Eye, KeyRound, Baby, Armchair, Wind, Shirt,
  PawPrint, Coffee, Home, Refrigerator, Microwave, Bath, ShowerHead, Dumbbell,
  Bike, Wine, Utensils, UtensilsCrossed, Fan, BedDouble, BookOpen, Gamepad2,
  FireExtinguisher, Luggage, DoorOpen, Zap, Droplet, Sparkles, SprayCan, Table,
  Siren, Piano, ShieldCheck, CalendarCheck,
  FileText, Users, Accessibility, Camera, Sofa, Footprints, Mountain, Building2,
} from "lucide-react";

export const AMENITY_ICONS = {
  Wifi, Snowflake, Flame, CookingPot, WashingMachine, Tv, Car, ArrowUpDown,
  PanelTop, Sun, Trees, Waves, Eye, KeyRound, Baby, Armchair, Wind, Shirt,
  PawPrint, Coffee, Home, Refrigerator, Microwave, Bath, ShowerHead, Dumbbell,
  Bike, Wine, Utensils, UtensilsCrossed, Fan, BedDouble, BookOpen, Gamepad2,
  FireExtinguisher, Luggage, DoorOpen, Zap, Droplet, Sparkles, SprayCan, Table,
  Siren, Piano, ShieldCheck, CalendarCheck,
  FileText, Users, Accessibility, Camera, Sofa, Footprints, Mountain, Building2,
};

export function iconFor(name) {
  return AMENITY_ICONS[name] || Home;
}

// Full selectable services catalogue (source of truth for wizard + mini-site).
// label = Italian (admin/default), en = English (mini-site when lang === "en").
const AMENITIES_RAW = [
  { key: "accesso_lago", label: "Accesso diretto al lago", en: "Direct lake access", icon: "Waves" },
  { key: "accesso_spiaggia", label: "Accesso diretto alla spiaggia", en: "Direct beach access", icon: "Waves" },
  { key: "allarme_antincendio", label: "Allarme antincendio", en: "Fire alarm", icon: "Siren" },
  { key: "amaca", label: "Amaca", en: "Hammock", icon: "Armchair" },
  { key: "animali_gratis", label: "Animali ammessi gratuitamente", en: "Pets allowed (free)", icon: "PawPrint" },
  { key: "animali_extra", label: "Animali ammessi (costo extra)", en: "Pets allowed (extra fee)", icon: "PawPrint" },
  { key: "aria_condizionata", label: "Aria condizionata", en: "Air conditioning", icon: "Snowflake" },
  { key: "arredi_esterni", label: "Arredi da esterni", en: "Outdoor furniture", icon: "Armchair" },
  { key: "ascensore", label: "Ascensore", en: "Elevator", icon: "ArrowUpDown" },
  { key: "asciugacapelli", label: "Asciugacapelli", en: "Hair dryer", icon: "Wind" },
  { key: "asciugatrice", label: "Asciugatrice", en: "Dryer", icon: "WashingMachine" },
  { key: "biancheria_letto", label: "Biancheria da letto", en: "Bed linen", icon: "BedDouble" },
  { key: "biciclette", label: "Biciclette", en: "Bicycles", icon: "Bike" },
  { key: "biciclette_bambini", label: "Biciclette per bambini", en: "Kids' bicycles", icon: "Bike" },
  { key: "bide", label: "Bidè", en: "Bidet", icon: "Bath" },
  { key: "bollitore", label: "Bollitore", en: "Kettle", icon: "Coffee" },
  { key: "caffe", label: "Caffè", en: "Coffee", icon: "Coffee" },
  { key: "calici_vino", label: "Calici da vino", en: "Wine glasses", icon: "Wine" },
  { key: "caminetto", label: "Caminetto interno", en: "Indoor fireplace", icon: "Flame" },
  { key: "cancelletti_sicurezza", label: "Cancelletti di sicurezza per bambini", en: "Child safety gates", icon: "Baby" },
  { key: "casa_multilivello", label: "Casa su più livelli con scale", en: "Multi-level home with stairs", icon: "Home" },
  { key: "cassaforte", label: "Cassaforte", en: "Safe", icon: "KeyRound" },
  { key: "colazione", label: "Colazione", en: "Breakfast", icon: "Coffee" },
  { key: "congelatore", label: "Congelatore", en: "Freezer", icon: "Refrigerator" },
  { key: "console_gioco", label: "Console di gioco", en: "Game console", icon: "Gamepad2" },
  { key: "cortile", label: "Cortile", en: "Courtyard", icon: "Trees" },
  { key: "cucina", label: "Cucina", en: "Kitchen", icon: "CookingPot" },
  { key: "cucina_comune", label: "Cucina in comune", en: "Shared kitchen", icon: "CookingPot" },
  { key: "cucinotto", label: "Cucinotto", en: "Kitchenette", icon: "CookingPot" },
  { key: "culla", label: "Culla su richiesta", en: "Crib on request", icon: "Baby" },
  { key: "cuoco_privato", label: "Cuoco privato su richiesta", en: "Private chef on request", icon: "Utensils" },
  { key: "cuscini_coperte", label: "Cuscini e coperte aggiuntivi", en: "Extra pillows and blankets", icon: "BedDouble" },
  { key: "deposito_bagagli", label: "Deposito bagagli consentito", en: "Luggage drop-off allowed", icon: "Luggage" },
  { key: "doccia_aperto", label: "Doccia all'aperto", en: "Outdoor shower", icon: "ShowerHead" },
  { key: "estintore", label: "Estintore", en: "Fire extinguisher", icon: "FireExtinguisher" },
  { key: "ferro_stiro", label: "Ferro da stiro", en: "Iron", icon: "Shirt" },
  { key: "forno", label: "Forno", en: "Oven", icon: "CookingPot" },
  { key: "forno_microonde", label: "Forno a microonde", en: "Microwave", icon: "Microwave" },
  { key: "frigorifero", label: "Frigorifero", en: "Refrigerator", icon: "Refrigerator" },
  { key: "frullatore", label: "Frullatore", en: "Blender", icon: "CookingPot" },
  { key: "giardino", label: "Giardino privato", en: "Private garden", icon: "Trees" },
  { key: "giardino_comune", label: "Giardino in comune", en: "Shared garden", icon: "Trees" },
  { key: "sapone_doccia", label: "Sapone doccia", en: "Shower gel", icon: "Droplet" },
  { key: "barbecue", label: "Barbecue", en: "Barbecue", icon: "Flame" },
  { key: "idromassaggio", label: "Idromassaggio", en: "Hot tub", icon: "Waves" },
  { key: "ingresso_privato", label: "Ingresso privato", en: "Private entrance", icon: "DoorOpen" },
  { key: "kit_primo_soccorso", label: "Kit di primo soccorso", en: "First aid kit", icon: "ShieldCheck" },
  { key: "lavastoviglie", label: "Lavastoviglie", en: "Dishwasher", icon: "WashingMachine" },
  { key: "lavatrice", label: "Lavatrice", en: "Washing machine", icon: "WashingMachine" },
  { key: "lettini_prendisole", label: "Lettini prendisole", en: "Sun loungers", icon: "Sun" },
  { key: "libri_giocattoli", label: "Libri e giocattoli per bambini", en: "Books and toys for children", icon: "BookOpen" },
  { key: "libri_lettura", label: "Libri e materiale di lettura", en: "Books and reading material", icon: "BookOpen" },
  { key: "macchina_caffe", label: "Macchina per il caffè", en: "Coffee machine", icon: "Coffee" },
  { key: "palestra", label: "Palestra", en: "Gym", icon: "Dumbbell" },
  { key: "parcheggio_pagamento", label: "Parcheggio a pagamento in loco", en: "Paid parking on site", icon: "Car" },
  { key: "parcheggio_gratuito_loco", label: "Parcheggio gratuito in loco", en: "Free parking on site", icon: "Car" },
  { key: "parcheggio_gratuito_strada", label: "Parcheggio gratuito in strada", en: "Free street parking", icon: "Car" },
  { key: "parcheggio_gratuito_fuori", label: "Parcheggio gratuito non in loco", en: "Free parking off site", icon: "Car" },
  { key: "balcone", label: "Balcone", en: "Balcony", icon: "PanelTop" },
  { key: "pianoforte", label: "Pianoforte", en: "Piano", icon: "Piano" },
  { key: "piatti_posate", label: "Piatti e posate", en: "Dishes and cutlery", icon: "Utensils" },
  { key: "piscina", label: "Piscina", en: "Pool", icon: "Waves" },
  { key: "ricarica_veicoli", label: "Postazione di ricarica per veicoli elettrici", en: "EV charging station", icon: "Zap" },
  { key: "prodotti_pulizia", label: "Prodotti per la pulizia", en: "Cleaning products", icon: "SprayCan" },
  { key: "rilevatore_monossido", label: "Rilevatore di monossido di carbonio", en: "Carbon monoxide detector", icon: "Siren" },
  { key: "riscaldamento", label: "Riscaldamento", en: "Heating", icon: "Flame" },
  { key: "sapone_corpo", label: "Sapone per il corpo", en: "Body soap", icon: "Droplet" },
  { key: "sauna", label: "Sauna", en: "Sauna", icon: "Flame" },
  { key: "seggiolone", label: "Seggiolone", en: "High chair", icon: "Baby" },
  { key: "servizi_cucinare_base", label: "Servizi di base per cucinare", en: "Basic cooking essentials", icon: "CookingPot" },
  { key: "servizi_spiaggia", label: "Servizi essenziali per la spiaggia", en: "Beach essentials", icon: "Waves" },
  { key: "pulizia_durante_soggiorno", label: "Servizio di pulizia durante il soggiorno", en: "Cleaning available during stay", icon: "Sparkles" },
  { key: "shampoo", label: "Shampoo", en: "Shampoo", icon: "Droplet" },
  { key: "soggiorni_lunghi", label: "Soggiorni lunghi possibili", en: "Long stays allowed", icon: "CalendarCheck" },
  { key: "spazio_lavoro", label: "Spazio di lavoro dedicato", en: "Dedicated workspace", icon: "PanelTop" },
  { key: "stendibiancheria", label: "Stendibiancheria per abiti", en: "Drying rack for clothing", icon: "Shirt" },
  { key: "tavolo_biliardo", label: "Tavolo da biliardo", en: "Pool table", icon: "Table" },
  { key: "tavolo_pingpong", label: "Tavolo da ping-pong", en: "Ping-pong table", icon: "Table" },
  { key: "tavolo_pranzo", label: "Tavolo da pranzo", en: "Dining table", icon: "Table" },
  { key: "tende_oscuranti", label: "Tende oscuranti", en: "Blackout curtains", icon: "PanelTop" },
  { key: "tostapane", label: "Tostapane", en: "Toaster", icon: "CookingPot" },
  { key: "tv", label: "TV", en: "TV", icon: "Tv" },
  { key: "utensili_barbecue", label: "Utensili da barbecue", en: "Barbecue utensils", icon: "Utensils" },
  { key: "vasca_bagno", label: "Vasca da bagno", en: "Bathtub", icon: "Bath" },
  { key: "ventilatore_soffitto", label: "Ventilatore a soffitto", en: "Ceiling fan", icon: "Fan" },
  { key: "ventilatore", label: "Ventilatore", en: "Fan", icon: "Fan" },
  { key: "wifi", label: "Wifi", en: "Wifi", icon: "Wifi" },
  { key: "zanzariera", label: "Zanzariera", en: "Mosquito net", icon: "PanelTop" },
  { key: "zona_pranzo_esterno", label: "Zona pranzo all'aperto", en: "Outdoor dining area", icon: "UtensilsCrossed" },
  { key: "finestra", label: "Finestra", en: "Window", icon: "PanelTop" },
  { key: "area_soggiorno", label: "Area soggiorno", en: "Living area", icon: "Armchair" },
  { key: "piscina_comune", label: "Piscina in comune", en: "Shared pool", icon: "Waves" },
  { key: "navetta_aeroportuale", label: "Navetta aeroportuale (a pagamento)", en: "Airport shuttle (surcharge)", icon: "Car" },
  { key: "fattura_richiesta", label: "Fattura disponibile su richiesta", en: "Invoice available on request", icon: "FileText" },
  { key: "terrazza", label: "Terrazza", en: "Terrace", icon: "Sun" },
  { key: "terrazza_comune", label: "Terrazza in comune", en: "Shared terrace", icon: "Sun" },
  { key: "sala_comune_tv", label: "Sala comune/zona TV", en: "Shared lounge / TV area", icon: "Tv" },
  { key: "solo_adulti", label: "Solo per adulti", en: "Adults only", icon: "Users" },
  { key: "accessibile_disabili", label: "Camere/struttura per ospiti disabili", en: "Accessible for guests with disabilities", icon: "Accessibility" },
  { key: "telecamere_esterno", label: "Telecamere nelle zone in comune o esterni", en: "Security cameras in common/exterior areas", icon: "Camera" },
  { key: "letto_pieghevole", label: "Letto pieghevole su richiesta", en: "Folding bed on request", icon: "BedDouble" },
  { key: "divano_letto", label: "Divano letto", en: "Sofa bed", icon: "Sofa" },
  { key: "armadio", label: "Armadio o guardaroba", en: "Wardrobe or closet", icon: "Shirt" },
  { key: "vasca", label: "Vasca", en: "Bathtub", icon: "Bath" },
  { key: "accappatoio", label: "Accappatoio", en: "Bathrobe", icon: "Shirt" },
  { key: "vasca_idromassaggio", label: "Vasca con idromassaggio", en: "Whirlpool bathtub", icon: "Bath" },
  { key: "doccia", label: "Doccia", en: "Shower", icon: "ShowerHead" },
  { key: "pantofole", label: "Pantofole", en: "Slippers", icon: "Footprints" },
  { key: "spazzolino", label: "Spazzolino da denti", en: "Toothbrush", icon: "Sparkles" },
  { key: "vista_citta", label: "Vista città", en: "City view", icon: "Building2" },
  { key: "vista_giardino", label: "Vista giardino", en: "Garden view", icon: "Trees" },
  { key: "vista_lago", label: "Vista lago", en: "Lake view", icon: "Waves" },
  { key: "vista_landmark", label: "Vista luogo di interesse", en: "Landmark view", icon: "Eye" },
  { key: "vista_montagna", label: "Vista montagna", en: "Mountain view", icon: "Mountain" },
  { key: "vista_piscina", label: "Vista piscina", en: "Pool view", icon: "Waves" },
  { key: "vista_mare", label: "Vista mare", en: "Sea view", icon: "Eye" },
  { key: "vista_cortile", label: "Vista sul cortile interno", en: "Inner courtyard view", icon: "Trees" },
  { key: "vista_strada_silenziosa", label: "Vista su una strada silenziosa", en: "Quiet street view", icon: "Eye" },
];

// Alphabetical (Italian) order — source of truth for wizard + mini-site.
export const AMENITIES = [...AMENITIES_RAW].sort((a, b) => a.label.localeCompare(b.label, "it"));

// Legacy keys used by existing properties (kept for display fallback only).
const LEGACY_META = {
  parcheggio: { label: "Parcheggio", label_en: "Parking", icon: "Car" },
  terrazza: { label: "Terrazza", label_en: "Terrace", icon: "Sun" },
  vista_mare: { label: "Vista mare", label_en: "Sea view", icon: "Eye" },
  pet_friendly: { label: "Animali ammessi", label_en: "Pets allowed", icon: "PawPrint" },
  self_checkin: { label: "Self check-in", label_en: "Self check-in", icon: "KeyRound" },
};

export const AMENITY_META = AMENITIES.reduce(
  (acc, a) => { acc[a.key] = { label: a.label, label_en: a.en, icon: a.icon }; return acc; },
  { ...LEGACY_META }
);

// Resolve a localized amenity label by key and language.
export function amenityLabel(key, lang) {
  const m = AMENITY_META[key];
  if (!m) return key;
  return lang === "en" && m.label_en ? m.label_en : m.label;
}

// ---- Categories (grouping for wizard + mini-site) ----
export const CATEGORIES = [
  { id: "cucina", it: "Cucina e pranzo", en: "Kitchen & dining" },
  { id: "bagno", it: "Bagno", en: "Bathroom" },
  { id: "camera", it: "Camera e comfort", en: "Bedroom & comfort" },
  { id: "clima", it: "Riscaldamento e climatizzazione", en: "Heating & cooling" },
  { id: "intrattenimento", it: "Intrattenimento", en: "Entertainment" },
  { id: "internet_lavoro", it: "Internet e lavoro", en: "Internet & workspace" },
  { id: "lavanderia", it: "Lavanderia", en: "Laundry" },
  { id: "esterni", it: "Esterni", en: "Outdoor" },
  { id: "viste", it: "Viste", en: "Views" },
  { id: "spazi_comuni", it: "Spazi comuni", en: "Common areas" },
  { id: "parcheggio", it: "Parcheggio e trasporti", en: "Parking & transport" },
  { id: "famiglia", it: "Famiglia e bambini", en: "Family & children" },
  { id: "sicurezza", it: "Sicurezza", en: "Safety & security" },
  { id: "accessibilita", it: "Accessibilità", en: "Accessibility" },
  { id: "servizi", it: "Servizi e regole", en: "Services & policies" },
];

const CAT_BY_KEY = {
  accesso_lago: "esterni", accesso_spiaggia: "esterni", allarme_antincendio: "sicurezza",
  amaca: "esterni", animali_gratis: "servizi", animali_extra: "servizi",
  aria_condizionata: "clima", arredi_esterni: "esterni", ascensore: "accessibilita",
  asciugacapelli: "bagno", asciugatrice: "lavanderia", biancheria_letto: "camera",
  biciclette: "esterni", biciclette_bambini: "famiglia", bide: "bagno",
  bollitore: "cucina", caffe: "cucina", calici_vino: "cucina", caminetto: "clima",
  cancelletti_sicurezza: "famiglia", casa_multilivello: "accessibilita", cassaforte: "sicurezza",
  colazione: "servizi", congelatore: "cucina", console_gioco: "intrattenimento",
  cortile: "esterni", cucina: "cucina", cucina_comune: "spazi_comuni", cucinotto: "cucina",
  culla: "famiglia", cuoco_privato: "servizi", cuscini_coperte: "camera",
  deposito_bagagli: "servizi", doccia_aperto: "esterni", estintore: "sicurezza",
  ferro_stiro: "lavanderia", forno: "cucina", forno_microonde: "cucina", frigorifero: "cucina",
  frullatore: "cucina", giardino: "esterni", giardino_comune: "spazi_comuni",
  sapone_doccia: "bagno", barbecue: "esterni", idromassaggio: "esterni",
  ingresso_privato: "accessibilita", kit_primo_soccorso: "sicurezza", lavastoviglie: "cucina",
  lavatrice: "lavanderia", lettini_prendisole: "esterni", libri_giocattoli: "famiglia",
  libri_lettura: "intrattenimento", macchina_caffe: "cucina", palestra: "intrattenimento",
  parcheggio_pagamento: "parcheggio", parcheggio_gratuito_loco: "parcheggio",
  parcheggio_gratuito_strada: "parcheggio", parcheggio_gratuito_fuori: "parcheggio",
  balcone: "esterni", pianoforte: "intrattenimento", piatti_posate: "cucina",
  piscina: "esterni", ricarica_veicoli: "parcheggio", prodotti_pulizia: "servizi",
  rilevatore_monossido: "sicurezza", riscaldamento: "clima", sapone_corpo: "bagno",
  sauna: "esterni", seggiolone: "famiglia", servizi_cucinare_base: "cucina",
  servizi_spiaggia: "esterni", pulizia_durante_soggiorno: "servizi", shampoo: "bagno",
  soggiorni_lunghi: "servizi", spazio_lavoro: "internet_lavoro", stendibiancheria: "lavanderia",
  tavolo_biliardo: "intrattenimento", tavolo_pingpong: "intrattenimento", tavolo_pranzo: "cucina",
  tende_oscuranti: "camera", tostapane: "cucina", tv: "intrattenimento",
  utensili_barbecue: "esterni", vasca_bagno: "bagno", ventilatore_soffitto: "clima",
  ventilatore: "clima", wifi: "internet_lavoro", zanzariera: "camera",
  zona_pranzo_esterno: "esterni", finestra: "camera", area_soggiorno: "camera",
  piscina_comune: "spazi_comuni", navetta_aeroportuale: "parcheggio", fattura_richiesta: "servizi",
  terrazza: "esterni", terrazza_comune: "spazi_comuni", sala_comune_tv: "spazi_comuni",
  solo_adulti: "servizi", accessibile_disabili: "accessibilita", telecamere_esterno: "sicurezza",
  letto_pieghevole: "camera", divano_letto: "camera", armadio: "camera", vasca: "bagno",
  accappatoio: "bagno", vasca_idromassaggio: "bagno", doccia: "bagno", pantofole: "bagno",
  spazzolino: "bagno", vista_citta: "viste", vista_giardino: "viste", vista_lago: "viste",
  vista_landmark: "viste", vista_montagna: "viste", vista_piscina: "viste", vista_mare: "viste",
  vista_cortile: "viste", vista_strada_silenziosa: "viste",
  // legacy keys
  parcheggio: "parcheggio", pet_friendly: "servizi", self_checkin: "servizi",
};

export function categoryFor(key) {
  return CAT_BY_KEY[key] || "servizi";
}

function _catLabel(c, lang) {
  return lang === "en" ? c.en : c.it;
}

// Ordered categories with their full amenity objects (for the wizard).
export function amenitiesByCategory(lang = "it") {
  const groups = {};
  for (const a of AMENITIES) (groups[categoryFor(a.key)] ||= []).push(a);
  return CATEGORIES.filter((c) => groups[c.id]?.length).map((c) => ({
    id: c.id,
    label: _catLabel(c, lang),
    items: [...groups[c.id]].sort((x, y) =>
      (lang === "en" ? x.en || x.label : x.label).localeCompare(lang === "en" ? y.en || y.label : y.label, "it")),
  }));
}

// Ordered categories from a list of selected keys (for the mini-site).
export function groupSelectedAmenities(keys = [], lang = "it") {
  const objs = keys.map((k) => ({ key: k, ...(AMENITY_META[k] || { label: k, icon: "Home" }) }));
  const groups = {};
  for (const a of objs) (groups[categoryFor(a.key)] ||= []).push(a);
  return CATEGORIES.filter((c) => groups[c.id]?.length).map((c) => ({
    id: c.id,
    label: _catLabel(c, lang),
    items: [...groups[c.id]].sort((x, y) => {
      const lx = lang === "en" ? x.label_en || x.label : x.label;
      const ly = lang === "en" ? y.label_en || y.label : y.label;
      return lx.localeCompare(ly, "it");
    }),
  }));
}

// Curated subset shown in the public search filter.
const POPULAR_KEYS = ["wifi", "aria_condizionata", "piscina", "parcheggio", "cucina", "lavatrice", "tv", "giardino", "balcone", "riscaldamento", "colazione", "vista_mare"];
export const POPULAR_AMENITIES = POPULAR_KEYS.map((k) => ({ key: k, ...(AMENITY_META[k] || { label: k, icon: "Home" }) }));
